// SCSS
import "./scss/app.scss";

// JS
import "./js/app.js";